<div
  class="container-fluid tw-bg-white tw-pb-24 tw-relative tw-bg-[url('/assets/images/puntosImage.png')] tw-min-h-[100dvh]"
  style="
    background-position: bottom;
    background-size: contain;
    background-repeat: no-repeat;
  "
>
  <div
    class="tw-relative tw-z-10 tw-container tw-mx-auto tw-px-4 md:tw-px-6 tw-h-full"
  >
    <div class="tw-flex tw-items-center tw-justify-center tw-h-full tw-py-12">
      <div
        class="tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-10 lg:tw-gap-16 tw-items-center tw-w-full"
      >
        <!-- Columna izquierda -->
        <div class="tw-text-center lg:tw-text-left tw-animate-fade-in">
          <h1
            class="tw-text-[#F67011] tw-text-3xl sm:tw-text-4xl md:tw-text-6xl tw-font-extrabold tw-mb-4 md:tw-mb-6 tw-leading-snug"
          >
            CONÉCTATE
            <span class="tw-text-black tw-block tw-text-wrap"
              >¡ESTAMOS AQUÍ PARA TÍ!</span
            >
          </h1>
          <p
            class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-text-justify tw-text-balance tw-text-gray-600 tw-max-w-md tw-mx-auto lg:tw-mx-0"
          >
            Nuestro equipo está listo para atenderte. No dudes en comunicarte
            con nosotros a través de cualquiera de nuestros canales.
          </p>
        </div>

        <!-- Columna derecha -->
        <div
          class="tw-bg-white tw-rounded-3xl tw-p-6 sm:tw-p-8 md:tw-p-12 lg:tw-p-16 tw-border-2 tw-border-[#F67011]/20 tw-shadow-2xl tw-w-full tw-max-w-2xl tw-mx-auto tw-animate-slide-up tw-transition-all hover:tw-shadow-[0_20px_50px_rgba(246,112,17,0.15)]"
        >
          <div class="tw-space-y-6 md:tw-space-y-8">
            <!-- WhatsApp (Contenedor completo clickeable) -->
            <a
              href="https://api.whatsapp.com/send/?phone=582813169200&text=Hola%2C+estoy+interesado+en+el+servicio+de+internet+por+fibra+%C3%B3ptica&type=phone_number&app_absent=0"
              target="_blank"
             class="tw-flex tw-items-start tw-gap-4 sm:tw-gap-6 tw-group tw-decoration-transparent tw-rounded-xl tw-p-3 hover:tw-bg-gray-100 tw-transition-all tw-cursor-pointer"
              aria-label="Contactar por WhatsApp"
            >
              <div
                class="tw-bg-[#F67011]/10 tw-p-3 sm:tw-p-4 tw-rounded-full tw-text-2xl sm:tw-text-4xl tw-text-[#F67011] group-hover:tw-bg-[#F67011] group-hover:tw-text-white tw-transition-all"
              >
                <i class="bi bi-whatsapp"></i>
              </div>
              <div class="tw-flex-1">
                <h3
                  class="tw-font-bold tw-text-black tw-text-lg sm:tw-text-xl md:tw-text-2xl tw-mb-1 tw-flex tw-items-center"
                >
                  WhatsApp
                </h3>
                <p
                  class="tw-text-gray-700 tw-text-base sm:tw-text-lg md:tw-text-xl"
                >
                  +58 281-3169200
                </p>
              </div>
              <i class="bi bi-chevron-right group-hover:tw-text-gray-800 tw-delay-150 tw-transition-all  tw-text-gray-400 tw-self-center tw-ml-2"></i>            </a>

            <!-- Email (Contenedor completo clickeable) -->
            <a
              href="mailto:info@onelink.net.ve"
              class="tw-flex tw-items-start tw-gap-4 sm:tw-gap-6 tw-group tw-decoration-transparent tw-rounded-xl tw-p-3 hover:tw-bg-gray-100 tw-transition-all tw-cursor-pointer"
              aria-label="Enviar correo electrónico"
            >
              <div
                class="tw-bg-[#F67011]/10 tw-p-3 sm:tw-p-4 tw-rounded-full tw-text-2xl sm:tw-text-4xl tw-text-[#F67011] group-hover:tw-bg-[#F67011] group-hover:tw-text-white tw-transition-all"
              >
                <i class="bi bi-envelope"></i>
              </div>
              <div class="tw-flex-1">
                <h3
                  class="tw-font-bold tw-text-black tw-text-lg sm:tw-text-xl md:tw-text-2xl tw-mb-1 tw-flex tw-items-center"
                >
                  Correo Electrónico
                </h3>
                <p
                  class="tw-text-gray-700 tw-text-base sm:tw-text-lg md:tw-text-xl"
                >
                  info&#64;onelink.net.ve
                </p>
              </div>
              <i class="bi bi-chevron-right group-hover:tw-text-gray-800 tw-delay-150 tw-transition-all  tw-text-gray-400 tw-self-center tw-ml-2"></i>            </a>

            <!-- Ubicación (Contenedor completo clickeable) -->
            <a
              href="https://maps.app.goo.gl/9GK4PoLV1UfYKexHA"
              target="_blank"
               class="tw-flex tw-items-start tw-gap-4 sm:tw-gap-6 tw-group tw-decoration-transparent tw-rounded-xl tw-p-3 hover:tw-bg-gray-100 tw-transition-all tw-cursor-pointer"
              aria-label="Ver ubicación en Google Maps"
            >
              <div
                class="tw-bg-[#F67011]/10 tw-p-3 sm:tw-p-4 tw-rounded-full tw-text-2xl sm:tw-text-4xl tw-text-[#F67011] group-hover:tw-bg-[#F67011] group-hover:tw-text-white tw-transition-all"
              >
                <i class="bi bi-geo-alt-fill"></i>
              </div>
              <div class="tw-flex-1">
                <h3
                  class="tw-font-bold tw-text-black tw-text-lg sm:tw-text-xl md:tw-text-2xl tw-mb-1 tw-flex tw-items-center"
                >
                  Visítanos
                </h3>
                <p
                  class="tw-text-gray-700 tw-text-balance tw-text-base sm:tw-text-lg md:tw-text-xl"
                >
                  Av. Intercomunal Andrés Bello <br />
                  C.C. Vistamar, Nivel PB, Local 16<br />
                  Urb. Ciudad Lechería, Anzoátegui<br />
                  Zona Postal 6001
                </p>
              </div>
              <i class="bi bi-chevron-right group-hover:tw-text-gray-800 tw-delay-150 tw-transition-all  tw-text-gray-400 tw-self-center tw-ml-2"></i>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>